import Vue from 'vue'
import VueCookie from 'vue-cookie'
Vue.use(VueCookie)
const cookie = VueCookie
export default ({ app }, inject) => {
  app.$cookie = cookie
  return cookie
}
